import * as actionTypes from "../ActionTypes";

export const readChurchesAction = (payload) => ({
  type: actionTypes.CHURCHES_READ_REQUEST,
  payload,
});

// Like Church Action
export const likeChurchAction = (payload) => ({
  type: actionTypes.LIKE_CHURCH_REQUEST,
  payload,
});

export const saveServiceVolunteerAction = (payload) => ({
  type: actionTypes.SAVE_SERVICE_VOLUNTEER_REQUEST,
  payload,
});

// Unlike Church Action
export const unlikeChurchAction = (payload) => ({
  type: actionTypes.UNLIKE_CHURCH_REQUEST,
  payload,
});

export const readFeaturedChurchesAction = (payload) => ({
  type: actionTypes.FEATURED_CHURCHES_READ_REQUEST,
  payload,
});

export const readFavouriteChurchesAction = (payload) => ({
  type: actionTypes.FAVOURITE_CHURCHES_READ_REQUEST,
  payload,
});

export const readHomeChurchesAction = (payload) => ({
  type: actionTypes.HOME_CHURCHES_READ_REQUEST,
  payload,
});
export const readNearbyChurchesAction = (payload) => ({
  type: actionTypes.NEARBY_CHURCHES_READ_REQUEST,
  payload,
});
